import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "novifood_token";

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export function setToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch {
        return null;
    }
}

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        // On 401 from any /admin or /auth/me request, clear token
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        if (status === 401 && (url.includes("/admin") || url.includes("/auth/me"))) {
            setToken(null);
        }
        return Promise.reject(err);
    }
);

export function formatApiError(detail) {
    if (detail == null) return "Algo correu mal. Tente novamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Resolve an image/media URL. Backend media (/api/...) needs the backend origin;
// frontend public assets (e.g. /brand/...) are served from the app origin.
export function mediaUrl(u) {
    if (!u) return "";
    if (u.startsWith("http")) return u;
    if (u.startsWith("/api")) return `${BACKEND_URL}${u}`;
    return u;
}
